module.exports = __webpack_public_path__ + "static/media/ein-2.e0e98d4c.jpg";